module.exports = __webpack_public_path__ + "img/icon_download_animated.7b492a10.png";